import { render, staticRenderFns } from "./RealVirtualView.vue?vue&type=template&id=77c0c5ee&scoped=true&"
import script from "./RealVirtualView.vue?vue&type=script&lang=js&"
export * from "./RealVirtualView.vue?vue&type=script&lang=js&"
import style0 from "./RealVirtualView.vue?vue&type=style&index=0&id=77c0c5ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c0c5ee",
  null
  
)

export default component.exports